import { EstadoLlaveAnual } from "../../bussines/entities/EstadisticasLlave.entity";

export class EstadoLlaveAnualModel implements EstadoLlaveAnual {
    constructor(
        public estado: string,
        public mes: number,
        public producto: string,
        public value: number

    ) { }

    serialize(): EstadoLlaveAnual {
        return {
            estado: this.estado,
            mes: this.mes,
            producto: this.producto,
            value: this.value
        }
    }

    static deserialize(entity: EstadoLlaveAnual): EstadoLlaveAnualModel {
        return new EstadoLlaveAnualModel(
            entity.estado ?? '',
            entity.mes ?? 0,
            entity.producto ?? '',
            entity.value ?? 0
        );
    }
}